/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils
import { buttonStyles, linkStyles, textStyles } from "utils/themeV2";


/* ++++++++++ --------------- EXPORT : AUTH RESET PASSWORD : STYLES --------------- ++++++++++ */
export default theme => ({
	resetpassword: {
        ...textStyles,
        ...linkStyles,
        ...buttonStyles
	}
});
